// dependencies
import { fromJS } from "immutable";

export default fromJS({
	graphWidth: 0,
	environmentRequestCount: 0,
	environmentMeanResponseTime: 0,
	environmentCompanyCount: 0,
	environmentActiveUserCount: 0,
	environmentTotalUserCount: 0,
	pageSize: 10,
	environmentBranches: {},
	requestsPerMinute: [],
	graphSelectionRange: [],
	graphSelectionRangeIndexes: [],
	graphSelection: { requests: [], count: 0, currentPage: 1 },
	userPerCompany: [],
});
